import { render, staticRenderFns } from "./SnapshotPhotoAdmin.vue?vue&type=template&id=59de4360"
import script from "./SnapshotPhotoAdmin.vue?vue&type=script&lang=js"
export * from "./SnapshotPhotoAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports